import type { ReactNode } from "react"

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
  Loader,
} from "@coval/ui"

interface WorkspaceActionDialogProps {
  open: boolean
  title: string
  description: ReactNode
  confirmLabel: string
  pendingLabel: string
  confirmVariant?: "default" | "danger"
  isPending: boolean
  isReady: boolean
  testId: string
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export function WorkspaceActionDialog({
  open,
  title,
  description,
  confirmLabel,
  pendingLabel,
  confirmVariant = "default",
  isPending,
  isReady,
  testId,
  onOpenChange,
  onConfirm,
}: WorkspaceActionDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button variant="secondary" disabled={isPending}>
              Cancel
            </Button>
          </AlertDialogCancel>
          <Button
            variant={confirmVariant}
            onClick={onConfirm}
            disabled={isPending || !isReady}
            data-testid={testId}
          >
            {isPending ? (
              <span className="inline-flex items-center gap-2">
                <Loader size="sm" />
                {pendingLabel}
              </span>
            ) : (
              confirmLabel
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
